import React from 'react';

export const HybridCourseFirstParagraph = () => (
  <p className="m-0">
    AP Classroom has updated the look and feel of its online test-taking
    experience and added features so you can begin to familiarize yourself with
    the question-responding experience of Bluebook™, the digital AP Exam
    application. While AP Classroom will allow students to type or upload
    answers to free-response questions, keep in mind that for this subject’s AP
    Exam, students will handwrite their answers to free-response questions in
    paper exam booklets.
  </p>
);

export const HybridCourseStudentFirstParagraph = () => (
  <p className="m-0">
    AP Classroom has updated the look and feel of its online test-taking
    experience and added features so you can begin to familiarize yourself with
    the question-responding experience of Bluebook™, the digital AP Exam
    application. While AP Classroom will allow you to type or upload answers to
    free-response questions, keep in mind that for this subject’s AP Exam, you
    will handwrite your answers to free-response questions in paper exam
    booklets.
  </p>
);

export const HybridCourseSecondParagraph = () => (
  <p className="m-0">
    We will also be updating the presentation of questions in AP Classroom to
    align more closely to Bluebook. For example, displaying more questions in a
    two-column layout. While this will take some time to implement, all
    questions in AP Classroom will continue to prepare your students for the
    content and skills assessed on the exam.
  </p>
);

export const HybridCourseThirdParagraph = ({ getBluebookDownloadURL }) => (
  <p className="m-0">
    When you get closer to the exam, you can further familiarize yourself with
    the test-taking experience that will be available on test day, including
    seeing section instructions and scheduled breaks, by{' '}
    <a href={getBluebookDownloadURL} target="_blank" rel="noreferrer">
      {' '}
      downloading Bluebook{' '}
    </a>{' '}
    and using the Test Preview for your subject.
  </p>
);

export const StudentLastParagraph = ({ getBluebookDownloadURL }) => (
  <p className="m-0">
    When you get closer to the exam, you can further familiarize yourself with
    the test-taking experience that will be available on test day, including
    seeing section instructions and scheduled breaks, by{' '}
    <a href={getBluebookDownloadURL} target="_blank" rel="noreferrer">
      {' '}
      downloading Bluebook{' '}
    </a>{' '}
    and using the Test Preview for your subject.
  </p>
);

export const NonEnglishBBCourseFirstParagraph = () => (
  <p className="m-0">
    AP Classroom has updated the look and feel of its online test-taking
    experience and added features so you can begin to familiarize yourself with
    the question-responding experience of Bluebook™, the digital AP Exam
    application.
  </p>
);

export const EnglishOrNonEnglishBBCourseFirstParagraph = () => (
  <p className="m-0">
    AP Classroom has updated the look and feel of its online test-taking
    experience and added features so you can begin to familiarize yourself with
    the question-responding experience of Bluebook™, the digital AP Exam
    application.
  </p>
);

export const NonEnglishBBCourseSecondParagraph = () => (
  <p className="m-0">
    We will also be updating the presentation of questions in AP Classroom to
    align more closely to Bluebook. For example, displaying more questions in a
    two-column layout. While this will take some time to implement, all
    questions in AP Classroom will continue to prepare your students for the
    content and skills assessed on the exam.
  </p>
);

export const NonEnglishBBCourseThirdParagraph = ({
  getBluebookDownloadURL,
}) => (
  <p className="m-0">
    When you get closer to the exam, you can further familiarize yourself with
    the test-taking experience that will be available on test day, including
    seeing section instructions and the scheduled breaks, by{' '}
    <a href={getBluebookDownloadURL} target="_blank" rel="noreferrer">
      {' '}
      downloading Bluebook{' '}
    </a>{' '}
    and using the Test Preview for your subject.
  </p>
);

export const EnglishBBCourseFirstParagraph = () => (
  <p className="m-0">
    AP Classroom has updated the look and feel of its online test-taking
    experience and added features so you can begin to familiarize yourself with
    the question-responding experience of Bluebook™, the digital AP Exam
    application.
  </p>
);

export const EnglishBBCourseSecondParagraph = () => (
  <p className="m-0">
    We will also be updating the presentation of questions in AP Classroom to
    align more closely to Bluebook. For example, including links from questions
    to referenced parts of the passage rather than solely relying on text
    references (like “In lines 1-7,…”). While this will take some time to
    implement, all questions in AP Classroom will continue to prepare your
    students for the content and skills assessed on the exam.
  </p>
);

export const EnglishBBCourseThirdParagraph = ({ getBluebookDownloadURL }) => (
  <p className="m-0">
    When you get closer to the exam, you can further familiarize yourself with
    the test-taking experience that will be available on test day, including
    seeing section instructions and scheduled breaks, by{' '}
    <a href={getBluebookDownloadURL} target="_blank" rel="noreferrer">
      {' '}
      downloading Bluebook{' '}
    </a>{' '}
    and using the Test Preview for your subject.
  </p>
);

export const FirstParagraph = ({ courseType, isStudent }) => {
  switch (courseType) {
    case 'HYBRID':
      return isStudent ? (
        <HybridCourseStudentFirstParagraph />
      ) : (
        <HybridCourseFirstParagraph />
      );
    case 'NON_ENGLISH_BB':
      return isStudent ? (
        <EnglishOrNonEnglishBBCourseFirstParagraph />
      ) : (
        <NonEnglishBBCourseFirstParagraph />
      );
    case 'ENGLISH_BB':
      return isStudent ? (
        <EnglishOrNonEnglishBBCourseFirstParagraph />
      ) : (
        <EnglishBBCourseFirstParagraph />
      );
    default:
      return null;
  }
};

export const SecondParagraph = ({ courseType }) => {
  switch (courseType) {
    case 'HYBRID':
      return <HybridCourseSecondParagraph />;
    case 'NON_ENGLISH_BB':
      return <NonEnglishBBCourseSecondParagraph />;
    case 'ENGLISH_BB':
      return <EnglishBBCourseSecondParagraph />;
    default:
      return null;
  }
};

export const ThirdParagraph = ({
  courseType,
  isStudent,
  getBluebookDownloadURL,
}) => {
  if (isStudent) {
    return (
      <StudentLastParagraph getBluebookDownloadURL={getBluebookDownloadURL} />
    );
  }

  switch (courseType) {
    case 'HYBRID':
      return (
        <HybridCourseThirdParagraph
          getBluebookDownloadURL={getBluebookDownloadURL}
        />
      );
    case 'NON_ENGLISH_BB':
      return (
        <NonEnglishBBCourseThirdParagraph
          getBluebookDownloadURL={getBluebookDownloadURL}
        />
      );
    case 'ENGLISH_BB':
      return (
        <EnglishBBCourseThirdParagraph
          getBluebookDownloadURL={getBluebookDownloadURL}
        />
      );
    default:
      return null;
  }
};

export const ModalText = ({
  courseType,
  isStudent,
  getBluebookDownloadURL,
}) => (
  <>
    <FirstParagraph courseType={courseType} isStudent={isStudent} />
    {!isStudent && <SecondParagraph courseType={courseType} />}
    <ThirdParagraph
      courseType={courseType}
      getBluebookDownloadURL={getBluebookDownloadURL}
      isStudent={isStudent}
    />
  </>
);

export const LabelForCheckBoxHybridCourse = ({ courseType, isStudent }) => {
  switch (courseType) {
    case 'HYBRID':
      return isStudent
        ? 'I understand that while AP Classroom practice assessments will prepare me for the experience of responding to digital AP Exam questions, the best representation of the exam experience I will have on test day is Bluebook’s Test Preview.'
        : 'I understand that while AP Classroom practice assessments will prepare my students for the experience of responding to digital AP Exam questions, the best representation of the exam experience on test day is Bluebook’s Test Preview.';
    case 'NON_ENGLISH_BB':
      return isStudent
        ? 'I understand that while AP Classroom practice assessments will prepare me for the experience of responding to digital AP Exam questions, the best representation of the exam experience I will have on test day is Bluebook’s Test Preview.'
        : 'I understand that while AP Classroom practice assessments will prepare my students for the experience of responding to digital AP Exam questions, the best representation of the exam experience on test day is Bluebook’s Test Preview.';
    case 'ENGLISH_BB':
      return isStudent
        ? 'I understand that while AP Classroom practice assessments will prepare me for the experience of responding to digital AP Exam questions, the best representation of the exam experience I will have on test day is Bluebook’s Test Preview.'
        : 'I understand that while AP Classroom practice assessments will prepare my students for the experience of responding to digital AP Exam questions, the best representation of the exam experience on test day is Bluebook’s Test Preview.';
    case 'NON_BB':
      return 'I understand that while the AP Classroom testing experience has been updated  to closely match Bluebook, this subject’s exam will not be administered in Bluebook in May 2025.';
    default:
      return null;
  }
};

export const NonBBCourseParagraph = () => (
  <p className="m-0">
    AP Classroom has begun to update the look and feel of its online test-taking
    experience and added features to closely match Bluebook™, the digital AP
    Exam application. While the May 2025 AP Exam for this subject will be the
    same as it has been in prior years and will not be administered in Bluebook,
    we want to provide students with a consistent testing experience in AP
    Classroom.
  </p>
);

export const StudentNonBBCourseParagraph = () => (
  <p className="m-0">
    AP Classroom has begun to update the look and feel of its online test-taking
    experience and added features to closely match Bluebook™, the digital AP
    Exam application. While the AP Exam for this subject is not being
    administered in Bluebook in May 2025, we want to provide you with a
    consistent assessment experience in AP Classroom.
  </p>
);
